var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "#ABAFC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.508 13.422v.414h-2.07l-.016-.453c-.102-1.227.328-1.93 1.406-2.563 1.008-.601 1.313-.984 1.313-1.726s-.594-1.281-1.485-1.281c-.898 0-1.492.57-1.539 1.453H8C8.04 7.344 9.398 6 11.797 6c2.234 0 3.71 1.242 3.71 3.023 0 1.18-.57 2-1.671 2.649-1.04.601-1.328.984-1.328 1.75zm.46 2.875c0 .805-.538 1.305-1.413 1.305s-1.422-.5-1.422-1.305c0-.813.547-1.313 1.422-1.313.875 0 1.414.5 1.414 1.313z",
    fill: "#fff"
  })));
}
export default SvgQMark;